export const Paths = {
    ROOT: 'alona',
    ABOUT: 'about',
    NOMNOM: 'nomnom',
    HATCH: 'hatchBaby',
    DS: 'design-system',
    TRANSPARENCY: 'transparency-by-design'
}
